import {
  formatPercentageValue,
  createKpiTileItem,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const {
      adoptionRatePercentage,
      adoptionRatePercentageDelta,
      adoptionRatePercentageTarget,
    } = data?.getUserAdoptionScorecard?.data || {};

    // Create tags array for both delta and target
    const tags = [];
    // Add target info if target exists and is not null
    if (adoptionRatePercentageTarget != null) {
      tags?.push({
        text: formatPercentageValue(adoptionRatePercentageTarget),
        sideLabel: 'Target',
        showArrow: false,
        isPositiveValue: true, // Target is usually displayed as neutral/positive
      });
    }
    // Add delta info if delta exists, is not zero, and is not undefined/null
    if (
      adoptionRatePercentageDelta != null &&
      !isNaN(adoptionRatePercentageDelta) &&
      Number(adoptionRatePercentageDelta)
    ) {
      tags?.push({
        isPositiveValue: adoptionRatePercentageDelta >= 0,
        text: formatPercentageValue(Math.abs(adoptionRatePercentageDelta)),
        sideLabel: '',
        showArrow: Number(adoptionRatePercentageDelta) !== 0,
      });
    }

    return createKpiTileItem(
      'Adoption Rate',
      formatPercentageValue(adoptionRatePercentage),
      tags.length > 0 ? tags : null
    );
  },
};
